import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import type { IconNames } from '@/shared/ui';

export const MAX_PSEUDO_PROGRESS = 97;

export const TIMELINE_ICON_BY_REPORT_TYPE: Record<ReportType, IconNames> = {
  [ReportType.ReportType_InvalidValue]: 'study',
  [ReportType.ReportType_CBCT_GP]: 'cbct3d',
  [ReportType.ReportType_CBCT_Endo]: 'cbct3d',
  [ReportType.ReportType_CBCT_Molar]: 'cbct3d',
  [ReportType.ReportType_Pano_GP]: 'pano3d',
  [ReportType.ReportType_Pano_Bitewings]: 'pano3d',
  [ReportType.ReportType_IOXRay_GP]: 'ioxray',
  [ReportType.ReportType_CBCT_Segmentation]: 'model3d',
  [ReportType.ReportType_CBCT_IOS_Superimposition]: 'model3d',
  [ReportType.ReportType_CBCT_Implant]: 'implant3d',
  [ReportType.ReportType_StudioImplant]: 'implant3d',
  [ReportType.ReportType_CBCT_OrthoSlides]: 'ortho3d',
  [ReportType.ReportType_StudioOrtho]: 'ortho3d',
  [ReportType.ReportType_IOS_Segmentation]: 'ios3d',
  [ReportType.ReportType_DentalPhoto_GP]: 'photo3dBold',
};

export const UPLOAD_WAITING_PROGRESS = 0;
export const PENDING_PROGRESS = 1;
